module.exports = "<div class=\"mj-card-body\">\n  <ng-content select=\"[card-body-content]\"></ng-content>\n</div>\n"